/* unplugin-vue-components disabled */import { render } from "./SurveyQuiz.vue?vue&type=template&id=72b3e507&scoped=true&ts=true"
import script from "./SurveyQuiz.vue?vue&type=script&lang=ts"
export * from "./SurveyQuiz.vue?vue&type=script&lang=ts"

import "./SurveyQuiz.vue?vue&type=style&index=0&id=72b3e507&scoped=true&lang=scss"
import "./SurveyQuiz.vue?vue&type=style&index=1&id=72b3e507&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b3e507"]])

export default __exports__